import type { Routes } from "@angular/router";
import { Cohort } from "./cohort/cohort";
import { Deposits } from "./deposits/deposits";
import { hasPermissionGuard } from "../../../guards/has-permission-guard";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../../services/layout.service";

export const reportsRoutes: Routes = [
  {
    path: 'cohort',
    loadComponent: () => Cohort,
    canActivate: [hasPermissionGuard],
    data: { permission: 'view reports cohort' },
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Relatórios e Análises - Cohort`;
    }
  },
  {
    path: 'deposits',
    loadComponent: () => Deposits,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Relatórios e Análises - Relatório de Depósitos`;
    }
  },
  {
    path: '',
    redirectTo: 'cohort',
    pathMatch: 'full',
  }
];
